import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// @ts-ignore lib
import { fetchPurchasesIfNeeded } from '@lootboy/lib/actions/PurchaseActions';
import { unopenedPurchasesSelector } from '@lootboy/lib/selectors';

import { useAppDispatch } from '~/redux/store/useAppDispatch';

export default function usePurchasesIndicator(): boolean {
  const dispatch = useAppDispatch();

  const invalidated = useSelector(
    // @ts-ignore lib
    ({ purchases: { didInvalidate } }) => didInvalidate,
  );
  useEffect(() => {
    dispatch(fetchPurchasesIfNeeded());
  }, [dispatch, invalidated]);

  return Boolean(useSelector(unopenedPurchasesSelector).length);
}
